module.exports = __webpack_public_path__ + "static/media/passengers-outline.ea7a895b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/passengers-outline.svg
// module id = 709
// module chunks = 0